import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "tw-flex tw-flex-row tw-items-center tw-justify-end tw-py-3.5"
};
const _hoisted_2 = { class: "tw-text-body-2 tw-mr-6" };
import { computed } from 'vue';
import ButtonIcon from '../button/icon/ButtonIcon.vue';
import { t } from '@/helpers/localization';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Pagination',
    props: {
        /** Defines the current page index of pagination. Only support positive values */
        currentPage: {
            type: Number,
            required: true,
            default: 1
        },
        /** Defines the total number of items that are paginated. */
        nItems: {
            type: Number,
            required: true
        },
        /** Defines the amount of items to show per page. */
        nItemsPerPage: {
            type: Number,
            required: true,
            default: 15
        }
    },
    setup(__props, { expose, emit: emits }) {
        const props = __props;
        const emitUpdatePagination = 'pageChanged';
        const range = computed(() => {
            return getRange(props.currentPage);
        });
        const getRange = function (page) {
            return {
                // Math.min helps to always get the lowest value, without exceeding total item length
                // Math.max prevents value start to be lesser than 1
                start: Math.min(Math.max(1, (page - 1) * props.nItemsPerPage + 1), props.nItems),
                end: Math.min(page * props.nItemsPerPage, props.nItems)
            };
        };
        const hasNextPage = function () {
            return props.currentPage < Math.ceil(props.nItems / props.nItemsPerPage);
        };
        const hasPreviousPage = function () {
            return props.currentPage > 1;
        };
        const notifyPageChanged = function (newPage) {
            const newRange = getRange(newPage);
            emits(emitUpdatePagination, {
                page: newPage,
                start: newRange.start - 1,
                end: newRange.end - 1
            });
        };
        const nextPage = function () {
            if (!hasNextPage()) {
                return;
            }
            notifyPageChanged(props.currentPage + 1);
        };
        const previousPage = function () {
            if (!hasPreviousPage()) {
                return;
            }
            notifyPageChanged(props.currentPage - 1);
        };
        expose({
            range,
            nextPage,
            previousPage
        });
        return (_ctx, _cache) => {
            return (__props.nItemsPerPage < __props.nItems)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('rangeOfN', {
                        start: _unref(range).start,
                        end: _unref(range).end,
                        nItems: __props.nItems
                    })), 1),
                    _createVNode(ButtonIcon, {
                        class: "tw-mr-2",
                        "icon-name": "arr-left",
                        large: "",
                        disabled: !hasPreviousPage(),
                        "data-test-id": "btn-previous-page",
                        onClick: previousPage
                    }, null, 8, ["disabled"]),
                    _createVNode(ButtonIcon, {
                        "icon-name": "arr-right",
                        large: "",
                        disabled: !hasNextPage(),
                        "data-test-id": "btn-next-page",
                        onClick: nextPage
                    }, null, 8, ["disabled"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
